import React from 'react'
import './footer.css'

export default function Footer() {
  return (
    <div>
          <footer>
        <p>Copyright &copy; Taqwa247 2023. All Rights Reserved.</p>
    </footer>
    </div>
  )
}
